<template>
    <div id="visitorRecord"> 
        <van-search v-model="dataName" @input="srNr" placeholder="请输入访客姓名单位名称" id="search" />
        <div id="noteList" :style="'height:'+noteHeight+'px'">
            <div id="nSBox">
                <div v-show="infoList!==null&&infoList.length>0">                    
                    <div v-for="(item,index) in infoList" @click="jump(item.id)" :key="index" class="noteBox">
                        <div class="left">
                            <div class="icon"><img :src="item.avatar"  alt=""></div>
                            <div class="left">
                                <div class="one">{{item.visitorStartTime}}</div>
                                <div>{{item.visitorEndTime}}</div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="tRightContent">
                                <div class="oneLine">
                                    <div>{{item.initiatorName}}</div>
                                    <div @click.stop="getMobile(item, index,item.isShowMobile)" >{{ item.isShowMobile ? item.noMobile : item.initiatorPhone }}</div>
                                    <van-icon class="icon" style="margin-left: 3px;"
                                        @click.stop="getMobile(item, index,item.isShowMobile)" v-if="!item.isShowMobile"
                                        name="eye-o" />
                                    <van-icon class="icon" style="margin-left: 3px;"
                                        @click.stop="getMobile(item,index, item.isShowMobile)" v-if="item.isShowMobile"
                                        name="closed-eye" />
                                </div>
                                <div class="word guestCompany text-ellipsis">{{item.gs}}</div>
                                <div class="word licensePlate text-ellipsis">{{item.cph}}</div> 
                            </div>
                            <div class="brContent">
                                <div class="word threeLine text-ellipsis">被访人：{{item.acceptName}}</div>
                                <div class="word threeLine text-ellipsis"  >同行人：<span>({{item.personNumber}})</span>
                                    <span v-for="(itemSon,indexSon) in item.personList.slice(1)" :key="indexSon">
                                        <span v-if="itemSon">
                                            {{itemSon}}
                                        </span>    
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            <van-empty v-show="(infoList===null||infoList.length<1)&&loading===false" description="暂无数据"/>
            <div class="tc" v-show="currentPage>1&&loading===true">{{loadingVal}}</div>
        </div>
    </div>
</template>
<script>
 import moment from 'moment'
export default {
    data(){
        return{
            totalPage:0,
            loading:false,
            label:'',
            noteHeight:'',
            dataName:'',
            currentPage:1,
            infoList:[],
            toastName:'',
            loadingVal:'加载中...'
        }
    },
    computed:{
         title(){
            return Object.keys(this.$store.state.inviteSubData).length > 0
            ? this.$store.state.inviteSubData.schoolName
            : JSON.parse(localStorage.getItem('userInfo')).schoolName
        }
    },
    mounted(){ 
        // console.log(document.getElementById('search').offsetHeight);        
        // console.log( document.getElementById('visitorRecord').innerHeight);
        // console.log( window.innerHeight);
        this.noteHeight=  window.innerHeight-46
        // console.log('我是内容');
        this.getFkList();
        document.getElementById('noteList').addEventListener('scroll',()=>{
            let allzhi=document.getElementById('noteList').scrollHeight;
           
            let sHeight=document.getElementById('noteList').scrollTop;
            let oHeight=document.getElementById('noteList').offsetHeight;
            // console.log(document.getElementById('noteList').offsetHeight);
            this.loading=true;
            if(allzhi===parseInt(sHeight+oHeight)){
                if(this.currentPage===this.totalPage){
                    this.loadingVal='没有更多了'
                    return;  
                } 
                var timeout; 
                clearTimeout(timeout);
                timeout = setTimeout(()=>{
                   this.currentPage+=1;
                    this.getFkList(); 
                    clearTimeout(timeout);
                },500); 
            }
        })
    },
    methods:{
        // 点击获取预约人手机号
        getMobile(data,index, bol) {
            if (!data.noMobile) { // 没有手机号
                this.$https.getVisitorMobile({
                    id: data.id
                }).then(res => {
                    if (res.code == 200) {
                        data.noMobile = res.data
                        data.isShowMobile = !bol
                        this.$set(this.infoList,index,data)

                    } else {
                        this.$toast(res.msg)
                    }
                })
            } else { // 有手机号
                data.isShowMobile = !bol
                this.$set(this.infoList,index,data)

            }
        },
        //输入内容
        srNr(){
            this.loading=true;
            this.toastName = this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            var timeout; 
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
               this.currentPage=1;
               this.getFkList(); 
               clearTimeout(timeout);
            },500); 
        },
        getDfTime(dfTime){
            let finallTime;
            let zhi=new Date();
            let xYear=moment(zhi).format('YYYY')
            let xM=moment(zhi).format('MM')
            let xDay=moment(zhi).format('DD')
            let dYear=dfTime.substr(0,4);
            let dM=dfTime.substr(5,2);
            let dDay=dfTime.substr(8,2);
            if(xYear===dYear&&xM===dM){
                if(dDay>xDay&&dDay-xDay===1){
                    finallTime='明天';
                }else if(dDay===xDay){
                    finallTime='今天';
                }else{
                    finallTime= dfTime.substr(0,10) 
                }
            }
            return finallTime;
        },
        async getFkList(){ 
            const {code,msg,data}=await this.$https.visitorRecord(
                {schoolId:JSON.parse(localStorage.getItem('userInfo')).schoolId?JSON.parse(localStorage.getItem('userInfo')).schoolId:' ',
                userId:JSON.parse(localStorage.getItem('userInfo')).id?JSON.parse(localStorage.getItem('userInfo')).id:' ',
                name:this.dataName,pageNum:this.currentPage,pageSize:10});
            this.loading=false;
            if(code===200){
                this.totalPage=data.totalPage
                if(this.currentPage>1){
                    let zhi=[];
                    // val.dateTimeFrom
                    data.list.forEach((val,index)=>{
                        zhi.push({
                            avatar:val.avatar, 
                            initiatorName:val.initiatorName,
                            initiatorPhone:val.initiatorPhone,
                            id:val.id,
                            visitorStartTime:this.getDfTime(val.visitorStartTime),
                            visitorEndTime:val.visitorStartTime.substr(val.visitorStartTime.indexOf('T')+1,5)+'-'+val.visitorEndTime.substr(val.visitorEndTime.indexOf('T')+1,5),
                            name:val.name,
                            idNumber:val.idNumber,
                            gs:val.guestCompany,
                            cph:val.licensePlate,
                            personNumber:val.personNumber-1,
                            acceptName:val.acceptName,
                            personList:val.personList.split(',') 
                        })
                    })
                    // [...data].dateTimeFrom=this.getDfTime(...data.dateTimeFrom)

                    this.infoList = [...this.infoList, ...zhi]; 
                }else{
                    
                     let zhi=[];
                    data.list.forEach((val,index)=>{
                        zhi.push({
                            avatar:val.avatar, 
                            initiatorName:val.initiatorName,
                            initiatorPhone:val.initiatorPhone,
                            id:val.id,
                            visitorStartTime: this.setTimeShow(val.visitorStartTime,val.visitorEndTime,'start')  ,
                            visitorEndTime: this.setTimeShow(val.visitorStartTime,val.visitorEndTime,'end') ,
                            name:val.name,
                            idNumber:val.idNumber,
                            gs:val.affiliatedUnit,
                            cph:val.carNumber,
                            personNumber:val.personNumber-1,
                            acceptName:val.acceptName,
                            personList:val.personList.split(',') 
                        })
                    })
                    this.infoList=zhi;
                    this.$toast.clear();
                }
                this.infoList.forEach(item => {
                    item.isShowMobile = false
                })
                 this.loadingVal='加载中...'
                 
                this.loading=false;
            }else{
                console.log('请求失败',msg)
                this.$toast(msg)
                this.loading=false;
                // this.$toast.clear();
            }
        },

        // 根据是否是今天的拜访时间决定视图显示样式
        setTimeShow (startTime,endTime,type) {
            if (type == 'start') {
                // 开始时间和结束时间都是今天
                if (this.getDfTime(startTime) == '今天' && this.getDfTime(endTime) == '今天') {
                    return '今天'
                }

                // 开始时间是今天结束时间不是今天
                if (this.getDfTime(startTime) == '今天' && this.getDfTime(endTime) != '今天') {
                    return '今天 ' + moment(startTime,'YYYY-MM-DDTHH:mm:ss.000+0000').format('HH:mm') + ' - '
                }
                // 开始时间结束时间都不是今天
                if (this.getDfTime(startTime) != '今天') {
                    return   moment(startTime,'YYYY-MM-DDTHH:mm:ss.000+0000').format('MM.DD HH:mm') + ' - '
                }

            } else if (type == 'end') {

                if (this.getDfTime(startTime) == '今天' && this.getDfTime(endTime) == '今天') {
                    return moment(startTime,'YYYY-MM-DDTHH:mm:ss.000+0000').format('HH:mm') + ' - ' + moment(endTime,'YYYY-MM-DDTHH:mm:ss.000+0000').format('HH:mm')
                } else {
                    return  moment(endTime,'YYYY-MM-DDTHH:mm:ss.000+0000').format('MM.DD HH:mm')
                }
            }
            return ''
        },


        jump(id){
          this.$router.push('/visitorDetail?id='+id);
        }
    }
}
</script>
<style lang="scss" scoped>  
    #visitorRecord{
        .tc{
            color: #a0a0a0;
            padding: 5px 0;
        }
        height:100%;
        .van-search{
            .van-search__content{
                border-radius: 20px;
            }
        }
        #noteList{ 
            padding:0.625rem 1rem;
            background: #F7F7FA;
            overflow-y: auto;
            border-radius: 0.5rem;
            .noteBox{
                padding:1.0625rem 1rem;
                background: #ffffff;
                display: flex;
                .left{
                    margin-right:0.625rem;
                   
                    .icon{
                        margin: 0 0 10px 0;
                        width:4rem;
                        height:4rem; 
                        img{
                            width:4rem;
                            height:4rem;
                            border-radius:0.3125rem;
                        }
                    }
                    .left{
                        .one{
                            text-align: center;
                        }
                        div{
                            height: 1rem;
                            font-size: 0.75rem;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 0.625rem;
                            color: #666666;
                            opacity: 1;
                        }
                    }
                    
                }
                .right{ 
                    .tRightContent{
                        >div{
                            margin: 0 0 5px 0;
                        }
                        .oneLine{
                            display: flex; 
                            height: 1.1875rem;
                            font-size: 0.875rem;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 1.1875rem;
                            color: #1A1A1A;
                            opacity: 1;
                            div:nth-of-type(1){
                                margin-right: 10px;
                            }
                        }
                        .twoLine{
                            height: 1rem;
                            font-size: 0.75rem;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 1rem;
                            color: #666666;
                            opacity: 1;
                        }
                        
                    }
                    .brContent{
                        margin-top: 5px;
                        >div{
                            margin-bottom: 5px;
                        }
                    }
                    .threeLine{
                        height: 0.9375rem;
                        font-size: 0.6875rem;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 0.9375rem;
                        color: #999999;
                        opacity: 1;
                    }
                }
            }
        }
    }
</style>